import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import ABTestBranchActionDetail from 'automation-ui-action-features/actions/ab-test-branch/ABTestBranchActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
const ABTestBranchActionHistoryCard = ({
  actionLabel,
  action,
  flowObjectTypeId
}) => {
  const connection = action.getConnection();
  const numOfBranches = connection.connections.length;
  return /*#__PURE__*/_jsx(LogEventRowAction, {
    title: actionLabel,
    content: /*#__PURE__*/_jsx(ABTestBranchActionDetail, {
      messageLangPath: "actionDetail",
      numOfBranches: numOfBranches,
      flowObjectTypeId: flowObjectTypeId
    })
  });
};
export default ABTestBranchActionHistoryCard;